export default __webpack_public_path__ + "assets/a87f11a93b123ba7054ae603517356e7.svg";